import Joi from 'joi';

export const AssignmentSchema = Joi.object({
  assignmentItems: Joi.array().items(Joi.number()).min(1).required(),
});
